import { createContext, useContext } from "react";
import { StreamChat } from "stream-chat";
import { ApplicationService } from "@domain/application/applicationService";
import { AuthService } from "@domain/auth/authService";
import { CarouselService } from "@domain/carousel/carouselService";
import { CurrencyService } from "@domain/currency/currencyService";
import { CurrentProfileService } from "@domain/currentProfile/currentProfileService";
import { FacebookService } from "@domain/currentProfile/facebookService/facebookService";
import { InstagramService } from "@domain/currentProfile/instagramService/instagramService";
import { LinkedinService } from "@domain/currentProfile/linkedinService/linkedinService";
import { TwitterService } from "@domain/currentProfile/twitterService/twitterService";
import { WhatsappService } from "@domain/currentProfile/whatsappService/whatsappService";
import { ExperienceService } from "@domain/experience/experienceService";
import { FilterService } from "@domain/filter/filterService";
import { GroupService } from "@domain/group/groupService";
import { WorkspaceService } from "@domain/group/workspace/workspaceService";
import { LivecourseService } from "@domain/livecourse/livecourseService";
import { ArticleService } from "@domain/lms/article/articleService";
import { CourseService } from "@domain/lms/course/courseService";
import { QuizService } from "@domain/lms/quiz/quizService";
import { MediaService } from "@domain/media/mediaService";
import { MessagingService } from "@domain/messaging/messagingService";
import { NotificationService } from "@domain/notification/notificationService";
import { OrganizationService } from "@domain/organization/organizationService";
import { TrackService } from "@domain/organization/track/trackService";
import { PostService } from "@domain/post/postService";
import { PrivacyService } from "@domain/privacy/privacyService";
import { SearchService } from "@domain/search/searchService";
import { SupportService } from "@domain/support/supportService";
import { TagsService } from "@domain/tags/tagsService";
import { TrackingService } from "@domain/tracking/trackingService";
import { UserService } from "@domain/user/userService";
import { UserKycService } from "@domain/userKyc/userKycService";
import { WalletService } from "@domain/wallet/walletService";

export interface Services {
	authService: AuthService;
	currentProfileService: CurrentProfileService;
	courseService: CourseService;
	searchService: SearchService;
	userService: UserService;
	mediaService: MediaService;
	postService: PostService;
	organizationService: OrganizationService;
	experienceService: ExperienceService;
	livecourseService: LivecourseService;
	trackingService: TrackingService;
	notificationService: NotificationService;
	quizService: QuizService;
	trackService: TrackService;
	groupService: GroupService;
	workspaceService: WorkspaceService;
	privacyService: PrivacyService;
	supportService: SupportService;
	// adminContentService: AdminContentService;
	articleService: ArticleService;
	tagsService: TagsService;
	carouselService: CarouselService;
	filterService: FilterService;
	currencyService: CurrencyService;
	userKycService: UserKycService;
	walletService: WalletService;
	messagingService: MessagingService;

	facebookService: FacebookService;
	twitterService: TwitterService;
	linkedinService: LinkedinService;
	whatsappService: WhatsappService;
	instagramService: InstagramService;
	applicationService?: ApplicationService;
	chatClient?: StreamChat;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ServicesContext = createContext<Services>(null as any);

export const useServices = (): Services => useContext(ServicesContext);
